/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { ChapterModel, ChapterModelType } from './ChapterModel'
import { ChapterModelSelector } from './ChapterModel.base'
import { TeacherModel, TeacherModelType } from './TeacherModel'
import { TeacherModelSelector } from './TeacherModel.base'
import { RootStoreType } from './index'

/**
 * LessonBase
 * auto generated base class for the model LessonModel.
 */
export const LessonModelBase = ModelBase.named('Lesson')
  .props({
    __typename: types.optional(types.literal('Lesson'), 'Lesson'),
    _id: types.identifier,
    chapters: types.union(types.undefined, types.array(types.late(() => ChapterModel))),
    createdAt: types.union(types.undefined, types.frozen()),
    description: types.union(types.undefined, types.string),
    duration: types.union(types.undefined, types.string),
    image: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    order: types.union(types.undefined, types.number),
    skills: types.union(types.undefined, types.array(types.string)),
    teacher: types.union(
      types.undefined,
      types.late(() => TeacherModel)
    ),
    updatedAt: types.union(types.undefined, types.frozen()),
    wpLessonId: types.union(types.undefined, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class LessonModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get description() {
    return this.__attr('description')
  }
  get duration() {
    return this.__attr('duration')
  }
  get image() {
    return this.__attr('image')
  }
  get name() {
    return this.__attr('name')
  }
  get order() {
    return this.__attr('order')
  }
  get skills() {
    return this.__attr('skills')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get wpLessonId() {
    return this.__attr('wpLessonId')
  }
  chapters(
    builder: string | ChapterModelSelector | ((selector: ChapterModelSelector) => ChapterModelSelector) | undefined
  ) {
    return this.__child('chapters', ChapterModelSelector, builder)
  }
  teacher(
    builder: string | TeacherModelSelector | ((selector: TeacherModelSelector) => TeacherModelSelector) | undefined
  ) {
    return this.__child('teacher', TeacherModelSelector, builder)
  }
}
export function selectFromLesson() {
  return new LessonModelSelector()
}

export const lessonModelPrimitives =
  selectFromLesson()._id.createdAt.description.duration.image.name.order.skills.updatedAt.wpLessonId
